import React, { createContext, useState, useEffect } from "react";
import { auth, db } from "../firebase/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { updateUserData, fetchUserData } from "../utils/userData";

export const ImageVisibilityContext = createContext({
  showImages: true,
  setShowImages: () => {},
});

export const ImageVisibilityProvider = ({ children }) => {
  const [showImages, setShowImagesState] = useState(true);

  useEffect(() => {
    let unsubscribe = () => {};
    const currentUser = auth.currentUser;

    if (currentUser) {
      const fromLS = localStorage.getItem(`showImages_${currentUser.uid}`);
      if (fromLS !== null) {
        setShowImagesState(JSON.parse(fromLS));
      }

      fetchUserData(currentUser.uid).then((userData) => {
        if (userData && typeof userData.showImages === "boolean") {
          setShowImagesState(userData.showImages);
          if (JSON.parse(fromLS ?? "true") !== userData.showImages) {
            localStorage.setItem(
              `showImages_${currentUser.uid}`,
              JSON.stringify(userData.showImages),
            );
          }
        } else if (userData && typeof userData.showImages === "undefined") {
          updateUserData(currentUser.uid, { showImages });
        }
      });

      const userDocRef = doc(db, "users", currentUser.uid);
      unsubscribe = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (typeof data.showImages === "boolean") {
            setShowImagesState(data.showImages);
            localStorage.setItem(
              `showImages_${currentUser.uid}`,
              JSON.stringify(data.showImages),
            );
          }
        }
      });
    }

    return () => unsubscribe();
  }, [auth.currentUser]);

  const setShowImages = async (value) => {
    const currentUser = auth.currentUser;
    setShowImagesState(value);
    localStorage.setItem(
      `showImages_${currentUser?.uid}`,
      JSON.stringify(value),
    );

    if (currentUser) {
      try {
        await updateUserData(currentUser.uid, { showImages: value });
      } catch (error) {
        console.error("Failed to update showImages in Firestore:", error);
      }
    }
  };

  return (
    <ImageVisibilityContext.Provider value={{ showImages, setShowImages }}>
      {children}
    </ImageVisibilityContext.Provider>
  );
};
